import {Component, computed, input, inject} from '@angular/core';
import {RotaAssignment} from '../../../../classes/models/rota/RotaAssignment';
import {Employee} from '../../../../classes/models/employee/Employee';
import moment from 'moment';
import {visibleRoles} from '../../../../classes/enums/RotaRole';
import {RotaDataService} from '../../../../services/store/rota-data.service';
import {DayOfWeek} from '../../../../classes/enums/DayOfWeek';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

/**
 * This component displays employee shop and role assignments for a day, on a daily rota page.
 */
@Component({
  selector: 'app-rota-day-work-day',
  templateUrl: './rota-day-work-day.component.html',
  styleUrls: ['./rota-day-work-day.component.less'],
  imports: [SHARED_IMPORTS]
})
export class RotaDayWorkDayComponent {
  private rotaDataService = inject(RotaDataService);


  /** The day of week of a rota. */
  dayOfWeek = input<DayOfWeek>();
  /** An employee in a rota. */
  employee = input<Employee>();
  /** A cell width (in pixels) of a daily rota grid. */
  cellWidth = input<number>();
  /** An hour, when the rota daily grid starts. */
  gridStartHour = input<string>();

  /** Rota assignment for a day and employee. */
  rotaAssignment = computed(() => this.rotaDataService.rota()?.rotaAssignments
          .find(assignment => assignment.hasEqualEmployeeAndDay(this.employee().employeePositionId, this.dayOfWeek())
          ));
  /** Role assignments for a day and employee. */
  roleAssignments = computed(() => this.rotaDataService.rota()?.roleAssignments
          .filter(assignment => assignment.hasEqualEmployeeAndDay(this.employee().employeePositionId, this.dayOfWeek()))
          .filter(assignment => visibleRoles().some(role => role === assignment.role)))


  /**
   * Finds a number of hours between a start and an end between an assignment.
   * @param assignment rota assignment, which duration should be displayed.
   */
  getDurationInHours(assignment: RotaAssignment): number {
    const momentStartTime = moment(assignment.startTime, 'HH:mm');
    const momentEndTime = moment(assignment.endTime, 'HH:mm');
    return momentEndTime.diff(momentStartTime, 'minutes') / 60;
  }
}
